import axios from 'app/axiosInstance'

export const getNotificationsList = () => {
    return axios().get(`v1/notification/_getBellNotifications`)
}

export const markNotificationRead = ids => {
    return axios().put(`v1/notification/_markAsRead`, ids)
}
